export interface Step {
	key: string;
	breadcrumbLabel?: string;
	isSubStep?: boolean;
	isHidden?: boolean;
	onNext?: () => unknown;
}

export enum Direction {
	Next = 1,
	Previous = -1,
}
